// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2joCz","boxTitle":"Qualiphy_boxTitle__3glkv","box":"Qualiphy_box__mdjs0","toggleWrap":"Qualiphy_toggleWrap__2mjxl"};